import React, { useEffect, useState } from "react";
import { useRemoteCursors } from "./RemoteCursorsProvider";
import { RemoteCursorOverlay } from "./RemoteCursorOverlay";
import { useOL } from "rlayers";
function RemoteCursorsMap() {
    const { setLocalCursorPosition, cursors } = useRemoteCursors();
    const [viewportSize, setViewportSize] = useState([0, 0]);
    const rlayersMap = useOL();
    const actualMap = rlayersMap.map;
    useEffect(() => {
        if (!actualMap)
            return;
        const updateSize = () => {
            const size = actualMap.getSize();
            setViewportSize(size || [0, 0]);
        };
        updateSize();
        actualMap.on("change:size", updateSize);
        return () => {
            actualMap.un("change:size", updateSize);
        };
    }, [actualMap]);
    useEffect(() => {
        if (!actualMap)
            return;
        const viewport = actualMap.getViewport();
        const handlePointerMove = (e) => {
            const rect = viewport.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const coordinate = actualMap.getCoordinateFromPixel([x, y]);
            setLocalCursorPosition({ x: coordinate[0], y: coordinate[1] });
        };
        const handlePointerLeave = () => {
            setLocalCursorPosition(null);
        };
        viewport.addEventListener("pointermove", handlePointerMove);
        viewport.addEventListener("pointerleave", handlePointerLeave);
        return () => {
            viewport.removeEventListener("pointermove", handlePointerMove);
            viewport.removeEventListener("pointerleave", handlePointerLeave);
        };
    }, [actualMap, setLocalCursorPosition]);
    useEffect(() => {
        if (!actualMap)
            return;
        const forceUpdate = () => {
            setViewportSize(prev => [...prev]);
        };
        actualMap.getView().on("change", forceUpdate);
        return () => {
            actualMap.getView().un("change", forceUpdate);
        };
    }, [actualMap]);
    if (!actualMap || viewportSize[0] === 0)
        return null;
    return (React.createElement("div", { className: "ol-overlay-container", style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            overflow: "hidden"
        } }, cursors.map(cursor => {
        if (!cursor.position)
            return null;
        const pixel = actualMap.getPixelFromCoordinate([cursor.position.x, cursor.position.y]);
        if (!pixel)
            return null;
        const [width, height] = viewportSize;
        const [x, y] = pixel;
        const isVisible = x >= 0 && y >= 0 && x <= width && y <= height;
        if (!isVisible)
            return null;
        return (React.createElement(RemoteCursorOverlay, { key: cursor.id, cursor: {
                ...cursor,
                position: {
                    x,
                    y
                }
            } }));
    })));
}
export default RemoteCursorsMap;
